<breadcrumb-layout>
	<breadcrumb-item-view (action)="goToArchive()">
		{{ 'common_archive' | translate }}
	</breadcrumb-item-view>
</breadcrumb-layout>
